import Master from "./Master";

const Lob = (props) => {
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const submitUrl = apiEndPoint + "/LoB/";
  const parentSource = apiEndPoint + "/LoBForSelect/";
  const getAllUrl = apiEndPoint + "/LoBAll/";
  const deleteUrl = apiEndPoint + "/LoB/";
  const masterProps = {
    masterlabel: "Line of Business",
    id: "lob-master",
    variant: "primary",
    submitUrl: submitUrl,
    getAllUrl: getAllUrl,
    deleteUrl: deleteUrl,
    primaryKey: "lob_id",
    newEntryForm: props?.newEntryForm === undefined ? true : props.newEntryForm,
    fields: [
      {
        label: "Name",
        props: { required: true },
        ref: "lob_name",
      },
      {
        label: "Parent",
        controlType: "select",
        props: { required: true },
        defaultLabel: "Select Parent LoB",
        options: [
          {
            label: "Root",
            value: 0,
          },
        ],
        dataUrl: parentSource,
        ref: "parent_lob_id",
        tableValue: "parent_lob_name",
      },
    ],
  };
  return <Master {...masterProps} />;
};
export default Lob;
